<template>
  <div class="questionnaire edit-style detail">
    <div class="navigation">
      <van-icon name="arrow-left" size="24" @click="goBack" />
      <p class="title">{{ questionData.title }}</p>
      <div class="hidden-box"></div>
    </div>
    <div class="banner-box">
      <div class="img-box">
        <img
          v-if="questionData.image"
          :src="questionData.image"
          alt=""
          class="bg"
        />
        <img v-else class="bg" src="@/assets/questionnaire/bg.png" alt="" />
      </div>

      <div class="msg-box">
        <p>{{ questionData.title }}</p>
        <span>
          {{ questionData.description }}
        </span>
        <div class="icon-box">
          <img src="@/assets/questionnaire/icon.png" alt="" />
        </div>
      </div>
    </div>
    <div
      v-if="questionData.questionList && questionData.questionList.length > 0"
      class="item-box"
    >
      <template v-for="(v, i) in questionData.questionList">
        <div v-if="v.type == 1" :key="i" class="item">
          <p>{{ i + 1 }}：{{ v.question }}</p>
          <van-radio-group
            v-if="v.answerList && v.answerList.length > 0"
            ref="radio-group"
            v-model="v.answer"
          >
            <template v-for="(m, n) in v.answerList">
              <van-radio :key="n" :name="m.answer"
                >{{ typeArr[n] }}：{{ m.name }}</van-radio
              >
            </template>
          </van-radio-group>
        </div>
        <div v-if="v.type == 2" :key="i" class="item">
          <p>{{ i + 1 }}：{{ v.question }}</p>
          <template v-for="(m, n) in v.answerList">
            <van-checkbox-group :key="n" v-model="v.answer">
              <van-checkbox :name="m.answer"
                >{{ typeArr[n] }}：{{ m.name }}</van-checkbox
              >
            </van-checkbox-group>
          </template>
        </div>
        <div v-if="v.type == 3" :key="i" class="item">
          <p>{{ i + 1 }}：{{ v.question }}</p>
          <van-field
            v-model="v.answer"
            rows="2"
            autosize
            label=""
            type="textarea"
            maxlength="50"
            placeholder="请输入"
            show-word-limit
          />
        </div>
      </template>
      <van-button
        type="primary"
        :loading="loading"
        block
        class="submit"
        @click="submit"
        >提交</van-button
      >
    </div>
  </div>
</template>

<script>
let typeArr = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"];
import { getQuestion, questionnaireAnswer } from "@/api/interface";
import { Toast } from "vant";
export default {
  name: "Questionnaire",
  data() {
    return {
      a: "",
      typeArr: typeArr,
      questionData: {},
      loading: false,
      apiData: {},
    };
  },
  created() {
    // this.getPhoneType();
    this.getPhoneType();
    // this.getList();
  },
  mounted() {
    // 判断是否在web端打开
    let type = this.$route.query.isWeb;
    if (type) {
      this.$store.commit("setToken", this.$route.query.token);
      this.$store.commit("setSchoolId", this.$route.query.schoolID);
      this.getList();
      // this.initSeaechData();
    } else {
      window.initView = this.initView;
      window.goBackView = this.goBackView;
      this.initMobile();
    }
    // window.initView = this.initView;
    // window.goBackView = this.goBackView;
    // this.initMobile();
  },
  methods: {
    getPhoneType() {
      let u = navigator.userAgent;
      // this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    downWindow() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 3,
        });
      } else {
        window.mobile.hideTitleBar();
      }
    },
    goBackView() {
      this.downView();
    },
    initMobile() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 2,
        });
      } else {
        window.mobile.initMobile();
      }
    },
    initView(data) {
      this.apiData = data;
      this.$store.commit("setToken", this.apiData.token);
      this.$store.commit("setSchoolId", this.apiData.schoolID);
      this.getList();
      this.downWindow();
    },
    downView() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 1,
        });
      } else {
        window.mobile.closeMobileUI();
      }
    },
    submit() {
      let str = "";
      let data = {
        token: this.apiData.token,
        qn_id: this.$route.query.id,
        // qn_id: "",
        answer: [],
      };
      this.questionData.questionList.forEach((i, a) => {
        if (i.answer == "") {
          str = str + (a + 1) + " ";
        }
        let answer = {};
        answer.question_id = i.id;
        // answer.question_id = "";
        if (i.type == 1 || i.type == 3) {
          answer.answer = i.answer;
        } else {
          answer.answer = i.answer.join(",");
        }
        data.answer.push(answer);
      });
      // console.log(data);
      if (str.length > 0) {
        Toast.fail(`第 ${str}题暂无答案`);
        return;
      }
      this.loading = true;
      questionnaireAnswer(data)
        .then(() => {
          Toast.success("提交成功");
          setTimeout(() => {
            this.loading = false;
            this.downView();
          }, 1500);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getList() {
      Object.assign(this.apiData, this.$route.query);
      // Object.assign(this.$route.query, this.apiData);
      // this.$store.commit("setToken", "cf4584af-65d6-4b49-9406-6a82bc510aec");
      // this.$store.commit("setSchoolId", 18);
      // let data = {
      //   id: 18
      // };
      getQuestion(this.apiData).then((res) => {
        this.questionData = res.data;
        this.questionData.questionList.map((index) => {
          index.answer = "";
          if (index.type == 1 || index.type == 2) {
            if (index.type == 2) {
              index.answer = [];
            }
            index.answerList = [];
            index.options.split("###").forEach((item, i) => {
              if (item) {
                index.answerList.push({
                  answer: i.toString(),
                  name: item,
                });
              }
            });
          }
        });
        this.questionData = JSON.parse(JSON.stringify(this.questionData));
      });
    },
    goBack() {
      this.downView();
    },
  },
};
</script>
<style scoped lang="scss">
.questionnaire {
  .submit {
    margin-bottom: 30px;
    border-radius: 6px;
    background-color: #7b9cc7;
    border-color: #7b9cc7;
  }
  .item-box {
    width: 90.5vw;
    margin: 22px auto 0;
    .item {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.04);
      padding: 12px;
      margin-bottom: 12px;
      div {
        margin-top: 8px;
      }
    }
  }
  .banner-box {
    width: 100vw;
    height: 32vw;
    position: relative;
    margin-bottom: 16vw;
    .img-box {
      position: absolute;
      width: 100vw;
      height: 32vw;
      left: 0;
      top: 0;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .msg-box {
      width: 90.5vw;
      height: 25.5vw;
      position: absolute;
      left: 4.25vw;
      top: 18.6vw;
      background-color: white;
      border-radius: 10px;
      box-shadow: 0px 2px 6px -4px rgba(16, 198, 148, 100);
      padding: 16px;
      .icon-box {
        width: 10.8vw;
        height: 10.8vw;
        box-shadow: 0px 2px 6px -3px rgba(0, 0, 0, 0.4);
        padding: 2.4vw;
        border-radius: 50%;
        position: absolute;
        left: 38.85vw;
        top: -6.4vw;
        background-color: white;
        img {
          width: 8vw;
        }
      }
      p {
        text-align: center;
        margin-bottom: 10px;
      }
      span {
        color: rgba(0, 0, 0, 0.5);
        font-size: 12px;
      }
    }
    // background-color: ;
  }
}
</style>
